import React from 'react'
import {BsToggleOn, BsToggle2Off} from 'react-icons/bs';
import VisDiv from './frontend_components/VisDiv';
import Divider from './frontend_components/Divider';

const TrueFalseToggle = ({value, onClick, label, description, descriptionDivider=true}) => {
    const icon = value
    ? <BsToggleOn className="toggle-icon-true" />
    : <BsToggle2Off className="toggle-icon-false"/>
  return (
    <div>
      <div style={{display:"flex", alignItems:"center"}}>
        <VisDiv style={{marginRight:"5px"}} rules={[label]}>
            <h4>{label}:</h4>
          </VisDiv>
          <button type="button" onClick={onClick} className="toggle-button">
              {icon}
          </button>
      </div>
      <VisDiv rules={[description]}>    
        <p>{description}</p>
        <VisDiv rules={[descriptionDivider]}>
          <Divider/>
        </VisDiv>
       
      </VisDiv>
    </div>
  )
}

export default TrueFalseToggle
